import { Activity, AlertTriangle, Clock3, Database, Gauge, ShieldCheck, Wifi } from "lucide-react";
import { getAccountRuntimeTruth } from "../lib/accountRuntime";
import { formatIndianTime, formatUtcTime } from "../lib/operatorFormatters";

const money = (value) => value == null ? "—" : `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

function Tile({ icon: Icon, label, value, detail, tone = "" }) {
  return (
    <div className={`mission-tile ${tone}`} role="status">
      <div className="mission-tile-label"><Icon size={13} /> {label}</div>
      <strong>{value}</strong>
      <small>{detail}</small>
    </div>
  );
}

export default function MissionStrip({ status }) {
  const runtimeTruth = getAccountRuntimeTruth(status);
  const account = status?.account || {};
  const scanner = status?.scanner || {};
  const data = status?.data_health || {};
  const feedLive = Boolean(data.websocket_fresh);
  const feedState = !status ? "PENDING" : !status.running ? "PAUSED" : feedLive ? "LIVE" : "STALE";
  const scanAt = scanner.last_scan_at ? formatIndianTime(scanner.last_scan_at) : "—";
  return (
    <section className="mission-strip" aria-label="Mission status">
      <Tile icon={Activity} label="Engine" value={runtimeTruth.executionLabel} detail={runtimeTruth.executionDetail} tone={runtimeTruth.executionTone === "running" ? "positive" : runtimeTruth.executionTone === "danger" ? "danger" : "muted"} />
      <Tile
        icon={ShieldCheck}
        label="Risk guard"
        value={!runtimeTruth.loaded ? "CHECKING" : runtimeTruth.riskLocked ? "LOCKED" : "ARMED"}
        detail={runtimeTruth.reconciliationBlocked ? "reconciliation blocks execution" : runtimeTruth.riskLocked ? "entries blocked" : "entries protected"}
        tone={!runtimeTruth.loaded ? "muted" : runtimeTruth.riskLocked ? "danger" : "positive"}
      />
      <Tile icon={Wifi} label="Market feed" value={feedState} detail={data.last_message_at ? `mark ${formatIndianTime(data.last_message_at)}` : !status?.running ? "engine stopped" : "waiting for mark prices"} tone={feedLive ? "positive" : status?.running ? "warning" : "muted"} />
      <Tile icon={Database} label="Free margin" value={money(account.available_margin)} detail={`used ${money(account.used_margin)}`} />
      <Tile icon={Gauge} label="Exposure" value={money(status?.risk?.exposure)} detail={`${status?.risk?.open_trades || 0}/${status?.risk?.max_concurrent_trades || 0} open`} />
      <Tile icon={Clock3} label="Last scan" value={scanAt} detail={`${scanner.scanned_count || 0} symbols · ${scanner.last_error_count || 0} errors`} tone={scanner.last_error_count ? "warning" : ""} />
      {runtimeTruth.reconciliationBlocked && (
        <Tile
          icon={AlertTriangle}
          label="Reconcile"
          value={["error", "failed"].includes(runtimeTruth.reconciliationStatus) ? "FAILED" : "REQUIRED"}
          detail={runtimeTruth.reconciliationReason}
          tone="danger"
        />
      )}
    </section>
  );
}
